import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  debug(message: string, meta?: unknown): void {
    if (environment.production) {
      return;
    }
    console.debug(message, this.sanitizeMeta(meta));
  }

  info(message: string, meta?: unknown): void {
    if (environment.production) {
      return;
    }
    console.info(message, this.sanitizeMeta(meta));
  }

  warn(message: string, meta?: unknown): void {
    if (environment.production) {
      return;
    }
    console.warn(message, this.sanitizeMeta(meta));
  }

  error(message: string, meta?: unknown): void {
    console.error(message, this.sanitizeMeta(meta));
  }

  private sanitizeMeta(meta: unknown): unknown {
    if (!meta) {
      return undefined;
    }

    if (meta instanceof Error) {
      return {
        name: meta.name,
        message: meta.message,
        stack: environment.production ? undefined : meta.stack,
      };
    }

    if (meta instanceof Object && environment.production) {
      return this.stripStack(meta as Record<string, unknown>);
    }

    return meta;
  }

  private stripStack(meta: Record<string, unknown>): Record<string, unknown> {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(meta)) {
      if (key.toLowerCase().includes('stack')) {
        continue;
      }
      result[key] = value;
    }
    return result;
  }
}
